export class CreateGcpVpcPeeringInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "peerProjectId",
            "baseName": "peerProjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "peerNetwork",
            "baseName": "peerNetwork",
            "type": "string",
            "format": ""
        },
        {
            "name": "cidrs",
            "baseName": "cidrs",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateGcpVpcPeeringInput.attributeTypeMap;
    }
    constructor() {
    }
}
